export default __webpack_public_path__ + "static/media/joinme.f40190b4.png";